/* + + + + + + MAIN MENU + + + + + + */

function enableHoverOnMainMenu(){
    //let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    let items = document.querySelectorAll(".header__inline-menu details");
    let dropdownItems = document.querySelector(".header__submenu");
    items.forEach(item => {
        item.addEventListener("mouseenter", () => {
            item.setAttribute("open", true);
        });
        item.addEventListener("focus", () => {
            item.setAttribute("open", true);
        });
        item.addEventListener("blur", () => {
            item.removeAttribute("open");
        });
        item.addEventListener("mouseenter", () => {
            item.setAttribute("open", "");
        });
        item.addEventListener("mouseleave", (e) => {
            item.removeAttribute("open");
        });
    });
    if (dropdownItems !== null) {
        dropdownItems.addEventListener("mouseleave", () => {
            items.forEach(item => {
                item.removeAttribute("open");
            });
        });
    }
}
enableHoverOnMainMenu();


/* + + + + + + HELPERS + + + + + + */

function waitForFlickity(callback, interval = 100, timeout = 5000) {
    const startTime = Date.now();
    function poll() {
        if (window.Flickity !== undefined) {
            callback();
        } else if (Date.now() - startTime < timeout) {
            setTimeout(poll, interval);
        } else {
            console.error('Timeout waiting for Flickity to load.');
        }
    }

    poll();
}


/* + + + + + + FILTER + + + + + + */

function insertPriceRangeFilter(){
    //check if to start
    const priceRangeElem = document.querySelector('#vaeng-price-range');
    if(!priceRangeElem){
        return;
    }
    //used flag
    let wasUsed = false;
    //get input fields
    const filterInputFrom = document.querySelector('input[name="filter.v.price.gte"]');
    const filterInputTo = document.querySelector('input[name="filter.v.price.lte"]');
    //get min and max values
    let minVal = Math.floor(parseFloat(filterInputTo.min));
    let maxVal = Math.ceil(parseFloat(filterInputFrom.max));
    //init slider
    let slideInstance = new rSlider({
        target: priceRangeElem,
        values: {min: minVal, max: maxVal},
        set: [minVal, maxVal],
        step: 1,
        range: true,
        scale: false,
        labels: false,
        onChange: function(vals){
            const minMaxVals = vals.split(',');
            let setMinVal = parseInt(minMaxVals[0]);
            let setMaxVal = parseInt(minMaxVals[1]);
            //Check if to apply filter
            if(minVal !== setMinVal || maxVal !== setMaxVal){
                wasUsed = true;
            }
            if(!wasUsed){
                return;
            }
            // //if full value window is chosen deselect all to remove any filter
            // if(minVal === setMinVal || maxVal === setMaxVal){
            //     setMinVal = '';
            //     setMaxVal = '';
            // }
            //set vals to exisiting input fields
            filterInputFrom.value = setMinVal;
            filterInputTo.value = setMaxVal;
            //trigger event to tell Shopify
            const event = new Event('input', { bubbles: true });
            filterInputFrom.dispatchEvent(event);
            filterInputTo.dispatchEvent(event);
        }
    });
    //check when to reInit (for Firefox)
    priceRangeElem.closest('details').addEventListener('click', function(){
        setTimeout(function(){
            slideInstance.onResize();
        }, 100);
    });
    //Observe and reApply
    setInterval(function(){
        if(!document.querySelector('#vaeng-price-range-container > .rs-container')){
            insertPriceRangeFilter();
        }
    }, 100);
}
insertPriceRangeFilter();


function insertRasenflaecheRangeFilter(){
    //check if to start
    const areaInputElems = document.querySelectorAll('.facets__disclosure-vertical ul:not(.no-js) input[name="filter.p.m.global.Rasenflaeche"]');
    if(!areaInputElems.length){
        return;
    }
    //helper class
    areaInputElems[0].closest('details').classList.add('vaeng-rasenflaeche-range-filter');
    //used flag
    let wasUsed = false;
    //get values (of all inputs)
    let values = [];
    areaInputElems.forEach(function(areaInputElem){
        values.push(areaInputElem.value);
    });
    //insert dummy input
    areaInputElems[0].closest('fieldset').insertAdjacentHTML('beforebegin', '<div id="vaeng-rasenflaeche-range-container"><input id="vaeng-rasenflaeche-range"></div>');
    //get min and max values
    let minVal = parseInt(values[0]);
    let maxVal = parseInt(values[values.length-1]);
    //init slider
    let slideInstance = new rSlider({
        target: '#vaeng-rasenflaeche-range',
        values: {min: minVal, max: maxVal},
        set: [maxVal],
        step: 1,
        range: false,
        scale: false,
        labels: false,
        onChange: function(val){
            const setMaxVal = parseInt(val);
            //Check if to apply filter
            if(maxVal !== setMaxVal){
                wasUsed = true;
            }
            if(!wasUsed){
                return;
            }
            //check matching inputs
            areaInputElems.forEach(function(areaInputElem){
                //if max is chosen deselect all to remove any filter
                if(setMaxVal === maxVal){
                    if(areaInputElem.checked){
                        areaInputElem.click();
                    }
                }
                else{
                    if(areaInputElem.value <= setMaxVal){
                        if(!areaInputElem.checked){
                            areaInputElem.click();
                        }
                    }
                    else{
                        if(areaInputElem.checked){
                            areaInputElem.click();
                        }
                    }
                }
            });
        }
    });
    //check when to reInit (for Firefox)
    areaInputElems[0].closest('details').addEventListener('click', function(){
        setTimeout(function(){
            slideInstance.onResize();
        }, 100);
    });
    //Observe and reApply
    setInterval(function(){
        if(!document.querySelector('#vaeng-rasenflaeche-range-container > .rs-container')){
            insertRasenflaecheRangeFilter();
        }
    }, 100);
}
insertRasenflaecheRangeFilter();


/* + + + + HOME: COLLECTION TABS + + + + */

window.addEventListener("load", function() {
    // store tabs variable
    var myTabs = document.querySelectorAll("ul.nav-tabs > li");
    function myTabClicks(tabClickEvent) {
        for (var i = 0; i < myTabs.length; i++) {
            myTabs[i].classList.remove("active");
        }
        var clickedTab = tabClickEvent.currentTarget;
        clickedTab.classList.add("active");
        tabClickEvent.preventDefault();
        var myContentPanes = document.querySelectorAll(".tab-pane");
        for (i = 0; i < myContentPanes.length; i++) {
            myContentPanes[i].classList.remove("active");
        }
        var anchorReference = tabClickEvent.target;
        var activePaneId = anchorReference.getAttribute("href");
        var activePane = document.querySelector(activePaneId);
        activePane.classList.add("active");
        //Slider
        var carousel = document.querySelector(activePaneId+' .vaeng-collection-tab-collection-products');
        var flkty = Flickity.data(carousel);
        flkty.resize();
    }
    for (i = 0; i < myTabs.length; i++) {
        myTabs[i].addEventListener("click", myTabClicks)
    }
});


/* + + + + HOME: MAIN SLIDESHOW ReInit (lazy loading pics) + + + + */

const reInitHomeSlider = function(){
    const homeSliderElems = document.querySelectorAll('.vaeng-slideshow');
    homeSliderElems.forEach((homeSliderElem) => {
        const homeSliderFlkty = Flickity.data(homeSliderElem);
        homeSliderFlkty.resize();
    });
};
// setTimeout(reInitHomeSlider, 1000);
// setTimeout(reInitHomeSlider, 2000);
// setTimeout(reInitHomeSlider, 3000);

waitForFlickity(() => {
    const homeSliderElems = document.querySelectorAll('.vaeng-slideshow');
    homeSliderElems.forEach((homeSliderElem) => {
        const homeSliderFlkty = Flickity.data(homeSliderElem);
        homeSliderFlkty.stopPlayer();
        homeSliderFlkty.selectCell(0);

        homeSliderFlkty.playPlayer();
    });
});

setTimeout(function(){
    //Remove hidden class
    const homeSliderContainer = document.querySelector('.vaeng-slideshow-container');
    if(homeSliderContainer){
        homeSliderContainer.classList.remove('vaeng-slideshow-slider-hidden');
    }
    setTimeout(reInitHomeSlider, 1000);
},5000);


/* + + + + PDP: MODAL SLIDER + + + + */

waitForFlickity(() => {
    const modalContentElem = document.querySelector('.product-media-modal__content');
    if(modalContentElem){
        const pdpModalSliderFlkty = new Flickity(modalContentElem, {
            cellAlign: 'center',
        });
        var productThumbnailListElem = document.querySelector('.product .thumbnail-list');
        if(productThumbnailListElem){
            productThumbnailListElem.addEventListener('click', function(e){
                const thumbnailListItemElem = e.target.closest('.thumbnail-list__item');
                if(thumbnailListItemElem){
                    const posId = thumbnailListItemElem.dataset.mediaPosition;
                    pdpModalSliderFlkty.select(posId-1);
                }
            });
        }
    }
});


/* + + + + WISHLIST + + + + */

function getWishlistItemsCount(){
    const wishlistItemCountElem = document.querySelector('a[href="#wishlist"] > .item_count_icon');
    if(wishlistItemCountElem){
        return wishlistItemCountElem.innerHTML;
    }
    return 0;
}

function updateItemsWishlistIcon(){
    setTimeout(function(){
        document.querySelector('#vng-header-wishlist-icon').dataset.hasItems = getWishlistItemsCount();
    }, 500);
}

function openWishlist(){
    document.querySelector('a[href="#wishlist"]').click();
}

function itemIsOnWishlist(){
    return !!document.querySelector('section[id^="MainProduct-"] .wishlist_btn.added');
}

//Init
updateItemsWishlistIcon();

//Clicks
document.addEventListener('click', function(e){
    const clickedElem = e.target;

    if(clickedElem.closest('#vng-add-to-wishlist')){
        if(!itemIsOnWishlist()){
            document.querySelector('section[id^="MainProduct-"] .wishlist_btn').click();
            updateItemsWishlistIcon();
        }
        openWishlist();
    }

    if(clickedElem.closest('#vng-header-wishlist-icon')){
        openWishlist();
    }
});
